import { Dispatch, SetStateAction } from "react";
import { Edge, ReactFlowInstance, XYPosition } from "reactflow";
import { Instance, InstanceMap } from "../../triggers/semantic-dive/semantic-dive";
import { uuid } from "../../utils";
import { duplicateNode } from "../node.helper";
import { createTopicNodeToReturn } from "../topic-node/topic-node.helper";
import { TypeTopicNode } from "../topic-node/topic-node.model";
import { HierarchyNodeData, hierarchyRootNodeId, TypeHierarchyNode } from "./hierarchy-node.model"

export const getChildHierarchyNodes = (
  hierarchyNodeId: string,
  instanceMap: InstanceMap,
) => {
  console.log(instanceMap);
  return Object.values(instanceMap)
    .filter(instance => instance.parentId === hierarchyNodeId);
}

export const createHierarchyNode = (
  [instanceMap, setInstanceMap]: [InstanceMap, Dispatch<SetStateAction<InstanceMap>>],
  reactFlowInstance: ReactFlowInstance,
) => {

  const newTopic: TypeTopicNode = createTopicNodeToReturn(
    '',
    '',
    {
      x: window.innerWidth/2 + 700,
      y: window.innerHeight/2,
    },
    [],
    false
  );

  const hierarchyId = `hierarchy-${newTopic.id}`;

  reactFlowInstance.setNodes((nodes) =>
    nodes.concat([{
      id: hierarchyId,
      type: 'hierarchy',
      position: {
        x: 0,
        y: 0,
      },
      data: {
        topicNode: newTopic,
        state: {
          isEditing: true,
        },
      } as HierarchyNodeData,
    }])
  );

  const newInstance: Instance = {
    parentId: newTopic.data.parentId,
    topicNode: newTopic,
    jsonObject: {
      nodes: [newTopic],
      edges: [],
      viewport: { x: 0, y: 0, zoom: 1 },
    },
    level: 0,
    canvasImageURL: '',
    position: { x: 0, y: 0 },
  };

  instanceMap[newTopic.id] = newInstance;
  // instanceMap[newTopic.data.parentId].jsonObject.nodes.push(duplicateNode(newTopic));
  setInstanceMap(instanceMap);

  // the edge between the clicked node and the child node is created
  reactFlowInstance.addEdges({ id: `hierarchy-edge-${newTopic.id}`, source: hierarchyRootNodeId, target: hierarchyId });

  console.log(reactFlowInstance.getNodes());

  // Focus in on textarea
  setTimeout(() => {
    const hierarchyNodeElement = document.querySelector(`[data-id="${hierarchyId}"]`) as HTMLElement
    (hierarchyNodeElement.getElementsByClassName('text-input')[0] as HTMLInputElement)?.focus();
  }, 100);

  return newInstance;
}